module.exports = __webpack_public_path__ + "static/media/delivery.102e3322.svg";